import { registerIcons,unregisterIcons } from '@fluentui/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from '../src/App';
import reportWebVitals from '../src/reportWebVitals';
import './utils/arrayUtils'; // for extension methods
import './utils/sortUtils'; // for extension methods
import { cleanupLocalStorage } from './utils/localStorageUtils';
import extraIcons from './extraIcons';

// Currently StrictMode causes issues with FluentUI surfaces during development, so it's disabled by default.
// Set this to true if you want to have strict mode checks, sacrificing tooltips and drag&drop features for DEV.
const strictModeChecks = false;

cleanupLocalStorage();

unregisterIcons(['SortUp', 'SortDown']);
registerIcons({ icons: extraIcons });

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const container = document.getElementById('root')!;
const root = createRoot(container);

if (strictModeChecks) {
    root.render(
        <React.StrictMode>
                    <App />
        </React.StrictMode>
    );
  }
  else {
    root.render(
        <App />
    );
  }
  
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
